/**
 * AccountController.java 对应的 model
 */

import Model from './model'
const REMEMBER_ME_KEY = '_spring_security_remember_me=1'
const model = new Model()
class Account {
    /**
     * 未读消息条数
     */
    static getUnread() {
        return model.post('account/getUnread')
    }

    /**
     * 切换登录角色
     * @param employerType 切换到至用户类型
     * @returns {*}
     */
    static switchRole(employerType) {
        // return model.post(`account/updateEmployerType?employerType=${employerType}`)
    }

    /**
     * 登录
     * @param username 用户名
     * @param password 密码
     * @param rememberMe 记住我?
     * @returns {*}
     */
    static login(username, password, rememberMe = false) {
        return model.post(`account/login${rememberMe ? '?' + REMEMBER_ME_KEY : ''}`, { username, password })
    }

    /**
     * 退出登录
     */
    static logout() {
        return model.post('account/logout')
    }

    /**
     * 搜索
     * @param account 登录名/ 邮箱/ 手机
     * @returns {*}
     */
    static getByAccountExcluding(account) {
        return model.post('account/getByAccountExcluding?account=' + account)
    }

    /**
     * 我的财产!
     * @returns {*}
     */
    static getWealth() {
        return model.post('account/getEmployerAccountInfo')
    }

    /**
     * 我的统计信息!
     * @returns {*}
     */
    static getStatInfo() {
        return model.post('account/getStatEmployerInfo')
    }

    /**
     * 用户套餐信息
     * @return {*}
     */
    static getCurrentVipInfo() {
        return model.post('account/getCurrentVipInfo')
    }

    /**
     * 微信支付增购
     *
     */
    static wxPayExt(opts) {
        return model.post('purchase/wxScanPayVip', opts)
    }

    static accountPay(opts) {
        return model.post('purchase/accountPayVip', opts)
    }

    static getPointsReward() {
        return model.get('account/getPointsReward')
    }

    static cancelPoints() {
        return model.get('account/cancelPointsReward')
    }

    static drawPoints() {
        return model.get('account/drawPointsReward')
    }
}
export default Account



// WEBPACK FOOTER //
// ./bootsets/models/account.js